<ng-container *ngIf="embedded; else analysisInputExpanded">
  <div *ngIf="category" class="analysis-input-container" (click)="$event.stopPropagation()">
    <ng-container *ngTemplateOutlet="analysisInputBody"></ng-container>
  </div>
</ng-container>
<ng-template #analysisInputExpanded>
  <mat-expansion-panel
    *ngIf="category"
    class="custom-mat-expansion-panel analysis-input-expansion-panel"
    [class.collapsed]="collapsedCategories?.has(category.id)"
    [expanded]="!collapsedCategories?.has(category.id)"
    [hideToggle]="true"
  >
    <mat-expansion-panel-header class="analysis-input-expansion-panel-header">
      {{ category.name }}
    </mat-expansion-panel-header>
    <div class="analysis-input-container">
      <ng-container *ngTemplateOutlet="analysisInputBody"></ng-container>
    </div>
  </mat-expansion-panel>
</ng-template>

<ng-template #analysisInputBody>
  <ng-container [ngSwitch]="category.stepTask">
    <!-- TEXT INPUT -->
    <mat-form-field *ngSwitchCase="StepTask.TEXT">
      <textarea
        matInput
        [id]="category.name"
        [attr.aria-label]="category.name"
        cdkTextareaAutosize
        [(ngModel)]="textValue"
        (ngModelChange)="onTextInputChange($event)"
        [attr.data-cy]="'analysis_text_' + category.name"
        [disabled]="isViewMode"
      ></textarea>
    </mat-form-field>

    <!-- CLASSIFICATION INPUT -->
    <ng-container *ngSwitchCase="StepTask.CLASSIFICATION">
      <!-- CHECKBOXES -->
      <ng-container *ngIf="steps[category.stepId]?.multiple; else switcher">
        <div [id]="category.name" class="multiple-container">
          <ng-container *ngFor="let optionId of category.options">
            <mat-checkbox
              [checked]="selectedOptions.includes(optionId)"
              (change)="onCheckboxChange($event, optionId)"
              [disabled]="isViewMode"
            >
              {{ options[optionId]?.name }}
            </mat-checkbox>
          </ng-container>
        </div>
      </ng-container>

      <!-- RADIO BUTTONS -->
      <ng-template #switcher>
        <mat-radio-group
          [id]="category.name"
          [attr.data-cy]="'analysis_switcher_' + category.name"
          [(ngModel)]="selectedOption"
          (change)="onRadioChange($event.value)"
          [disabled]="isViewMode"
        >
          <mat-radio-button
            *ngFor="let optionId of category.options"
            [value]="optionId"
            [attr.aria-label]="options[optionId]?.name"
          >
            {{ options[optionId]?.name }}
          </mat-radio-button>
        </mat-radio-group>
      </ng-template>
    </ng-container>

    <!-- UNKNOWN -->
    <ng-container *ngSwitchDefault> Unknown type: {{ category.stepTask }} </ng-container>
  </ng-container>
</ng-template>
